import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-carpetcleaning',
  templateUrl: './carpetcleaning.component.html',
  styleUrls: ['./carpetcleaning.component.css']
})
export class CarpetcleaningComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
